import * as React from "react";
import {StoreBase} from "shared/core/Store/StoreBase";
import {RNTextInput} from "shared/controls/SingleInputs/RNTextInput";
import {RNTextArea} from "shared/controls/SingleInputs/RNTextArea/RNTextArea";
import {SpinnerButton} from "shared/controls/SpinnerButton";
import {FontAwesomeIcon} from "shared/core/Controls/FontAwesome/FontAwesomeIcon";
import {faPaperPlane} from "@fortawesome/free-solid-svg-icons/faPaperPlane";
import {ToastService} from "shared/core/services/ToastService";
import {WpAjaxPost} from "shared/core/ajax/WPAjaxPost";

export class PreSaleQuestion extends React.Component<PreSaleQuestionProps, PreSaleQuestionState> {
    static defaultProps: Partial<PreSaleQuestionProps> = {};
    public Options:PreSaleOptions;
    constructor(props: PreSaleQuestionProps) {
        super(props);
        this.state = {
            IsBusy:false
        };
        this.Options=new PreSaleOptions().Merge({Source:rnFormVar.Source});
    }

    public render() {
        return (
            <div>
                <strong>Aren't you sure if this plugin fit your needs? do you want to know if something is possible? Let us know!</strong>

                <p style={{marginTop:10,fontStyle:'italic'}}>
                    <strong>Important:</strong> Please don't use this form to request support, for that please use the <a href={'#'} onClick={e=>{e.preventDefault();this.props.GoToContactForm();}}>Contact Support.</a> <br/> If you are using the free version of a plugin please go to wordpress.org and create a support thread in the plugin's page
                </p>
                <RNTextInput Store={this.Options} PropertyName={'Name'} Label={'Name'} />
                <RNTextInput Store={this.Options} PropertyName={'Email'} Label={'Email'} type={'text'} />
                <RNTextArea height={200} Label={'Message'} Store={this.Options} PropertyName={"Message"}/>
                <SpinnerButton OnClick={()=>this.Submit()} IsBusy={this.state.IsBusy} Icon={<FontAwesomeIcon icon={faPaperPlane}/>}>Submit</SpinnerButton>

            </div>
        )
    }


    private async Submit() {


        if(this.Options.Name.trim()=='')
        {
            ToastService.SendErrorMessage('Name can not be empty');
            return;
        }

        if(this.Options.Email.trim()=='')
        {
            ToastService.SendErrorMessage('Email can not be empty');
            return;
        }

        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if(!re.test(this.Options.Email))
        {
            ToastService.SendErrorMessage('Invalid email address');
            return;
        }

        if(this.Options.Message.trim()=='')
        {
            ToastService.SendErrorMessage('Message can not be empty');
            return;
        }

        this.setState({IsBusy:true});

        let result=await WpAjaxPost.Post('PreSaleQuestion',this.Options.ToObject());

        if(result!=null) {
            ToastService.SendSuccess('Message successfully send, you will get a reply from us soon');
            this.Options.Name='';
            this.Options.Email='';
            this.Options.Message='';
            this.forceUpdate();
        }
        this.setState({IsBusy:false});
    }

}

class PreSaleOptions extends StoreBase{
    public Name:string;
    public Email:string;
    public Message:string;
    public Source:string;



    protected LoadDefaultValues() {
        this.Name='';
        this.Email='';
        this.Message='';
        this.Source='';
    }

}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface PreSaleQuestionProps {
    GoToContactForm:()=>void;
}

interface PreSaleQuestionState {
    IsBusy:boolean;
}

//#endregion "My Region"